import { styled } from '@mui/material/styles'
import useTheme from '../hooks/useTheme'
import { THEMES } from '../constants'

import WhiteLogo from '../vendor/spine-white-logo-text.svg?react'
import BlueLogo from '../vendor/spine-blue-logo-text.svg?react'

const WhiteBrand = styled(WhiteLogo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 100%;
  height: 72px;
`

const BlueBrand = styled(BlueLogo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 100%;
  height: 72px;
`

export default function Brand() {
  /**
   * The theme.
   */
  const { theme } = useTheme()

  return <>{theme === THEMES.DARK ? <WhiteBrand /> : <BlueBrand />}</>
}
